export function getLast<T>(arr: T[]): T {
  return arr[arr.length - 1];
}


export const securityQuestions = [
  { value: "first_pet", label: "What was the name of your first pet?" },
  { value: "first_school", label: "What was the name of your first school?" },
  { value: "birth_city", label: "In what city were you born?" },
  { value: "childhood_nickname", label: "What was your childhood nickname?" },
  { value: "favorite_teacher", label: "What is the name of your favorite teacher?" },
  { value: "mothers_maiden_name", label: "What is your mother's maiden name?" },
  { value: "fathers_middle_name", label: "What is your father’s middle name?" },
  { value: "oldest_sibling", label: "What is the first name of your oldest sibling?" },
  { value: "met_spouse", label: "Where did you meet your spouse/partner?" },
  { value: "grandfathers_occupation", label: "What was your grandfather’s occupation?" },
  { value: "first_concert", label: "What was the name of the first concert you attended?" },
  { value: "first_car", label: "What was the model of your first car?" },
  { value: "first_vacation", label: "Where did you go on your first vacation?" },
  { value: "first_job", label: "What was your first job?" },
  { value: "first_boss", label: "What was the name of your first boss?" },
  { value: "favorite_book", label: "What is your favorite book?" },
  { value: "favorite_movie", label: "What is your favorite movie?" },
  { value: "favorite_toy", label: "What is your favorite childhood toy?" },
  { value: "favorite_restaurant", label: "What is your favorite restaurant?" },
  { value: "favorite_team", label: "What is your favorite sports team?" },
  { value: "street_grew_up", label: "What is the name of the street you grew up on?" },
  { value: "first_stuffed_animal", label: "What is the name of your first stuffed animal?" },
  { value: "first_phone_number", label: "What is the first phone number you remember?" },
  { value: "childhood_dream_job", label: "What was your dream job as a child?" },
  { value: "first_video_game", label: "What was the first video game you played?" },
];